// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/slow-flight.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/slow-flight/slow-flight.js';

mount([g0]);
